import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useDidMount } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setPushEnabled } from '../../../actions/filters';
import { selectFilters } from '../../../selectors/selectFilters';

export const usePushToggleController = () => {
  const { pushEnabled, estimationTarget } = useSelector(selectFilters);
  const dispatch = useDispatch();
  const [isPushVisible, setPushVisible] = React.useState(estimationTarget === EEstimationTargets.flat);

  const handlePushToggle = React.useCallback(
    (e: React.ChangeEvent, value: boolean) => {
      dispatch(setPushEnabled(value));
    },
    [dispatch],
  );

  useDidMount(() => {
    if (isPushVisible) {
      dispatch(setPushEnabled(true));
    }
  });

  React.useEffect(() => {
    const nextIsPushVisible = estimationTarget !== EEstimationTargets.newbuilding;

    setPushVisible(nextIsPushVisible);

    dispatch(setPushEnabled(nextIsPushVisible));
  }, [dispatch, estimationTarget]);

  return { isPushVisible, pushEnabled: Boolean(pushEnabled), handlePushToggle };
};
